import { useTranslation } from 'react-i18next';

import { usePartnerId } from 'hooks/usePartnerId';
import { useSchedule } from 'hooks/useSchedule';

export const useRedirectToSso = () => {
  const { i18n } = useTranslation();
  const { AppointmentInfo, sessionId } = useSchedule();
  const { partnerId } = usePartnerId();

  const getSsoUrl = (appointmentId?: string) => {
    let ssoUrl = new URL(`${process.env.NEXT_PUBLIC_SSO_URL}`);

    if (
      partnerId ===
      (process.env.NEXT_PUBLIC_CAPSULA_PUBLIC_PARTNER_ID ||
        '15085a39-b6d2-4a8d-a32d-4667f6d73c20')
    ) {
      ssoUrl = new URL(
        `${process.env.NEXT_PUBLIC_CAPSULA_URL}/${i18n.language}/auth/sign-in`,
      );
    }
    const originUrl = new URL(window.location.href);

    const params = new URL(document.location.href).searchParams;
    const lang = params.get('lang') || params.get('locale');

    if (!originUrl.pathname.startsWith('/schedule')) {
      ssoUrl.searchParams.set('origin', `${originUrl}`);

      ssoUrl.searchParams.set('lang', lang || i18n.language);

      return ssoUrl;
    }

    originUrl.pathname = '/api/redirect';

    if (appointmentId) {
      originUrl.searchParams.set('appointmentId', appointmentId);

      ssoUrl.searchParams.set('origin', `${originUrl}`);

      ssoUrl.searchParams.set('lang', lang || i18n.language);

      return ssoUrl;
    }

    if (sessionId) {
      originUrl.searchParams.set('sessionId', sessionId);
    }

    if (AppointmentInfo.startDate) {
      originUrl.searchParams.set(
        'startDate',
        AppointmentInfo.startDate.toISOString(),
      );
    }

    if (AppointmentInfo.doctorId) {
      originUrl.searchParams.set('doctorId', AppointmentInfo.doctorId);
    }

    if (AppointmentInfo.appointmentTime) {
      originUrl.searchParams.set(
        'startTime',
        AppointmentInfo.appointmentTime?.startTime,
      );

      originUrl.searchParams.set(
        'endTime',
        AppointmentInfo.appointmentTime?.endTime,
      );
    }

    if (AppointmentInfo.searchId) {
      originUrl.searchParams.set('searchId', AppointmentInfo.searchId);
    }

    originUrl.searchParams.set('quantity', AppointmentInfo.quantity.toString());

    originUrl.searchParams.set('reason', AppointmentInfo.reason);

    originUrl.searchParams.set('productId', AppointmentInfo.productId);

    originUrl.searchParams.set('productSlug', AppointmentInfo.productSlug);

    originUrl.searchParams.set('lang', lang || i18n.language);

    ssoUrl.searchParams.set('origin', `${originUrl}`);

    ssoUrl.searchParams.set('lang', lang || i18n.language);

    return ssoUrl;
  };

  return { getSsoUrl };
};
